import React, { useState, useEffect } from 'react';
import {
  RefreshIcon, CheckIcon, XIcon, PauseIcon, PlayIcon,
  PackageIcon, EyeIcon, ReceiptIcon, CalendarIcon,
  AlertIcon, ChevronIcon,
} from '../../components/Icons';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function AnunciosAdmin() {
  const [anuncios,   setAnuncios]   = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [activeTab,  setActiveTab]  = useState('pendente');
  const [erro,       setErro]       = useState('');
  const [sucesso,    setSucesso]    = useState('');

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setCarregando(true);
    try {
      const res  = await fetch(`${BASE}/admin/anuncios/todos`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      if (data.sucesso) setAnuncios(data.anuncios);
      else setErro(data.mensagem);
    } catch {
      // fallback — busca anúncios normais
      try {
        const r2   = await fetch(`${BASE}/anuncios?limit=50`);
        const d2   = await r2.json();
        if (d2.sucesso) setAnuncios(d2.anuncios);
      } catch (e) { setErro('Erro ao carregar anúncios'); }
    } finally { setCarregando(false); }
  };

  const moderar = async (id, estado, motivo = '') => {
    try {
      const res = await fetch(`${BASE}/admin/anuncios/${id}`, {
        method: 'PATCH',
        headers: { 'Content-Type':'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ estado, motivo }),
      });
      const data = await res.json();
      if (data.sucesso) {
        setSucesso(`Anúncio ${estado === 'ativo' ? 'aprovado' : 'rejeitado'}!`);
        setTimeout(() => setSucesso(''), 3000);
        carregar();
      } else setErro(data.mensagem);
    } catch { setErro('Erro ao moderar anúncio'); }
  };

  const tabs = [
    { id:'pendente',  label:'Pendentes',  cor:'#d97706' },
    { id:'ativo',     label:'Activos',    cor:'#16a34a' },
    { id:'rejeitado', label:'Rejeitados', cor:'#dc2626' },
    { id:'todos',     label:'Todos',      cor:'#64748b' },
  ];

  const filtrados = activeTab === 'todos'
    ? anuncios
    : anuncios.filter(a => a.estado === activeTab);

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Moderação de Anúncios</div>
          <div className="topbar-sub">{anuncios.filter(a=>a.estado==='pendente').length} pendentes · {anuncios.filter(a=>a.estado==='ativo').length} activos</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}><RefreshIcon size={14}/> Actualizar</button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'7px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'7px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

        {/* Tabs */}
        <div style={{display:'flex',gap:'8px',marginBottom:'20px',flexWrap:'wrap'}}>
          {tabs.map(t => (
            <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{
              padding:'7px 16px', borderRadius:'20px', border:'none', cursor:'pointer',
              fontFamily:'inherit', fontSize:'12px', fontWeight:'500', transition:'all 0.15s',
              background: activeTab===t.id ? t.cor : 'var(--card)',
              color:      activeTab===t.id ? '#fff' : 'var(--text-secondary)',
              border:     activeTab===t.id ? `1px solid ${t.cor}` : '1px solid var(--border)',
            }}>
              {t.label} ({t.id==='todos' ? anuncios.length : anuncios.filter(a=>a.estado===t.id).length})
            </button>
          ))}
        </div>

        {carregando ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>A carregar anúncios...</div>
        ) : filtrados.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px',color:'var(--text-muted)'}}>
            <PackageIcon size={40} color='var(--border)'/>
            <div style={{fontSize:'15px',fontWeight:'600',marginBottom:'6px',marginTop:'12px'}}>Nenhum anúncio {activeTab === 'pendente' ? 'pendente' : activeTab === 'ativo' ? 'activo' : activeTab}</div>
            <div style={{fontSize:'13px'}}>Os anúncios criados pelos fornecedores aparecem aqui.</div>
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:'14px'}}>
            {filtrados.map(a => <CardAnuncio key={a.id} anuncio={a} onModerar={moderar} />)}
          </div>
        )}
      </div>
    </>
  );
}

function CardAnuncio({ anuncio: a, onModerar }) {
  const [expandido, setExpandido] = useState(false);

  const estadoCores = {
    pendente:   { bg:'#fffbeb', border:'#fde68a', cor:'#d97706', label:'Pendente' },
    ativo:      { bg:'#f0fdf4', border:'#86efac', cor:'#16a34a', label:'Activo' },
    rejeitado:  { bg:'#fef2f2', border:'#fecaca', cor:'#dc2626', label:'Rejeitado' },
    pausado:    { bg:'#f1f5f9', border:'#e2e8f0', cor:'#64748b', label:'Pausado' },
  };
  const ec = estadoCores[a.estado] || estadoCores.pendente;

  const fotoUrl = a.fotos?.[0] || null;

  return (
    <div className="card" style={{border: a.estado==='pendente'?'1.5px solid #fde68a':'1px solid var(--border)'}}>
      {/* Header */}
      <div style={{display:'flex',gap:'14px',alignItems:'flex-start'}}>

        {/* Foto do anúncio */}
        <div style={{width:'80px',height:'80px',borderRadius:'10px',overflow:'hidden',flexShrink:0,background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px'}}>
          {fotoUrl
            ? <img src={fotoUrl} alt={a.titulo} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
            : <PackageIcon size={32} color='rgba(249,115,22,0.4)'/>
          }
        </div>

        {/* Info principal */}
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'10px',marginBottom:'6px'}}>
            <div>
              <div style={{fontSize:'15px',fontWeight:'600',color:'var(--text-primary)',marginBottom:'2px'}}>{a.titulo}</div>
              <div style={{fontSize:'12px',color:'var(--text-muted)'}}>{a.categoria_icone} {a.categoria_nome || 'Sem categoria'} · {a.localizacao || 'Sem localização'}</div>
            </div>
            <span style={{background:ec.bg,border:`1px solid ${ec.border}`,color:ec.cor,fontSize:'11px',fontWeight:'600',padding:'4px 10px',borderRadius:'20px',whiteSpace:'nowrap',flexShrink:0}}>
              {ec.label}
            </span>
          </div>

          {/* Fornecedor */}
          <div style={{display:'flex',alignItems:'center',gap:'8px',padding:'8px 12px',background:'var(--surface)',borderRadius:'8px',marginBottom:'8px'}}>
            {a.fornecedor_foto
              ? <img src={a.fornecedor_foto} alt={a.fornecedor_nome} style={{width:'32px',height:'32px',borderRadius:'50%',objectFit:'cover',border:'2px solid var(--border)'}} onError={e=>{e.target.style.display='none'}} />
              : <div style={{width:'32px',height:'32px',borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'13px',fontWeight:'700',color:'#fff',flexShrink:0}}>
                  {(a.fornecedor_nome||'?')[0].toUpperCase()}
                </div>
            }
            <div>
              <div style={{fontSize:'12px',fontWeight:'600',color:'var(--text-primary)'}}>{a.fornecedor_nome || 'Fornecedor desconhecido'}</div>
              <div style={{fontSize:'11px',color:'var(--text-muted)',display:'flex',gap:'8px'}}>
                <span style={{color: a.fornecedor_kyc==='verificado'?'var(--success)':'var(--warning)'}}>KYC: {a.fornecedor_kyc==='verificado'?'Verificado':'Pendente'}</span>
                <span>Avaliação: {a.fornecedor_rating||'—'}</span>
              </div>
            </div>
          </div>

          {/* Métricas */}
          <div style={{display:'flex',gap:'16px',flexWrap:'wrap'}}>
            <span style={{fontSize:'13px',fontWeight:'700',color:'var(--orange)'}}>{parseFloat(a.preco_dia||0).toLocaleString()} Kz/dia</span>
            <span style={{fontSize:'12px',color:'var(--text-muted)'}}>Caução: {parseFloat(a.caucao||0).toLocaleString()} Kz</span>
            <span style={{fontSize:'12px',color:'var(--text-muted)',display:'flex',alignItems:'center',gap:'3px'}}><EyeIcon size={11}/> {a.total_views||0} views</span>
            <span style={{fontSize:'12px',color:'var(--text-muted)',display:'flex',alignItems:'center',gap:'3px'}}><ReceiptIcon size={11}/> {a.total_reservas||0} reservas</span>
            <span style={{fontSize:'12px',color:'var(--text-muted)',display:'flex',alignItems:'center',gap:'3px'}}><CalendarIcon size={11}/> {new Date(a.created_at).toLocaleDateString('pt-PT')}</span>
          </div>
        </div>
      </div>

      {/* Fotos do anúncio */}
      {a.fotos?.length > 0 && (
        <div style={{display:'flex',gap:'6px',marginTop:'12px',flexWrap:'wrap'}}>
          {a.fotos.slice(0,6).map((f,i) => (
            <img key={i} src={f} alt={`foto ${i+1}`} style={{width:'60px',height:'60px',borderRadius:'6px',objectFit:'cover',border:'1px solid var(--border)',cursor:'pointer'}}
              onError={e=>e.target.style.display='none'} />
          ))}
          {a.fotos.length > 6 && (
            <div style={{width:'60px',height:'60px',borderRadius:'6px',background:'var(--surface)',border:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'12px',color:'var(--text-muted)'}}>
              +{a.fotos.length - 6}
            </div>
          )}
        </div>
      )}

      {/* Descrição expandida */}
      {expandido && a.descricao && (
        <div style={{marginTop:'12px',padding:'12px',background:'var(--surface)',borderRadius:'8px',fontSize:'13px',color:'var(--text-secondary)',lineHeight:'1.6'}}>
          {a.descricao}
        </div>
      )}

      {/* Acções */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:'14px',paddingTop:'12px',borderTop:'1px solid var(--border)'}}>
        <button onClick={()=>setExpandido(!expandido)} style={{background:'transparent',border:'none',fontSize:'12px',color:'var(--brand-mid)',cursor:'pointer',fontFamily:'inherit',fontWeight:'500',display:'flex',alignItems:'center',gap:'4px'}}>
          <ChevronIcon size={13} style={{transform: expandido?'rotate(180deg)':'rotate(0)',transition:'0.15s'}}/> {expandido ? 'Menos detalhes' : 'Ver descrição'}
        </button>
        <div style={{display:'flex',gap:'8px'}}>
          {a.estado === 'pendente' && <>
            <button onClick={()=>onModerar(a.id,'rejeitado','Não cumpre os requisitos')}
              style={{padding:'7px 14px',background:'var(--danger-bg)',color:'var(--danger)',border:'1px solid var(--danger-border)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px',fontWeight:'500',display:'flex',alignItems:'center',gap:'5px'}}>
              <XIcon size={12}/> Rejeitar
            </button>
            <button onClick={()=>onModerar(a.id,'ativo')} className="btn btn-success btn-sm" style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <CheckIcon size={12}/> Aprovar
            </button>
          </>}
          {a.estado === 'ativo' && (
            <button onClick={()=>onModerar(a.id,'pausado')}
              style={{padding:'7px 14px',background:'var(--warning-bg,#fffbeb)',color:'var(--warning,#d97706)',border:'1px solid var(--warning-border,#fde68a)',borderRadius:'7px',cursor:'pointer',fontFamily:'inherit',fontSize:'12px',fontWeight:'500',display:'flex',alignItems:'center',gap:'5px'}}>
              <PauseIcon size={12}/> Pausar
            </button>
          )}
          {(a.estado === 'rejeitado' || a.estado === 'pausado') && (
            <button onClick={()=>onModerar(a.id,'ativo')} className="btn btn-success btn-sm" style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <PlayIcon size={12}/> Activar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
